import React, { useContext, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import {
  Box, Button, Grid, IconButton, InputBase, Stack, Table, TableBody,
  TableContainer, TableHead, TableRow, Typography, Pagination, Backdrop,
  CircularProgress, Container, InputLabel, FormControl, Select, MenuItem,
  Divider, TextField, InputAdornment
} from "@mui/material";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import axios, { AxiosInstance } from "axios";
import RowPays from "./RowPays";
import Cookies from "universal-cookie";
import CheckAttr from "../../../../utils/CheckAttr";
import ClearIcon from "@mui/icons-material/Clear";
import { loggoutUser } from "../../../../redux/actions/logginUser";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { MediaQueryContext } from "../../../../utils/contextes/MediaQueryContext";
export interface IPays {
  id: number;
  libelle: string;
  created_at: string;
  updated_at: string;
  date_suppression: any;
  bus: Bus[];
}
interface Bus {
  id: number;
  libelle: string;
  created_at: string;
  updated_at: string;
  date_suppression: any;
}
export const tableStyle: React.CSSProperties = {
  backgroundColor: "transparent",
};

export const headerCellStyle: React.CSSProperties = {
  backgroundColor: "#FC8404",
  color: "white",
  fontWeight: "bold",
  alignItems: "center",
};

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    textAlign: "center",
    fontSize: 12,
  },
}));

const urlApi = process.env.REACT_APP_BASE_API_URL as string;

const Pays = () => {
  const { isDesktopOrLaptop } = useContext(MediaQueryContext);

  const cookies = new Cookies();
  const token: string = cookies.get("jwt");

  const http: AxiosInstance = axios.create({
    baseURL: urlApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [rowsPays, setRowsPays] = useState<IPays[]>([]);
  const [nb, setNb] = useState(0);
  const [rowPerPage, setRowPerPage] = useState(5);
  const [page, setPage] = useState<number>(1);
  const [libelleSearch, setLibelleSearch] = useState<string>("");
  const [libelleAjouter, setLibelleAjoute] = useState<string>("");
  const [isClickedBtn, setIsClickedBtn] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<boolean>(false);

  // Add global response interceptor
  http.interceptors.response.use(
    (response) => {
      // Modify response data here, if needed
      return response;
    },
    (error) => {
      console.log(error.message);
      if (error.message === "Request failed with status code 401") {
        // Remove the redux store
        dispatch(loggoutUser());

        // Remove token in navigator cookies
        cookies.remove('jwt', { path: '/' });

        navigate("/sign-in");
      }
      return Promise.reject(error);
    }
  );

  const reloadList = () => {
    setRefresh(!refresh);
  };

  const getData = () => {
    setIsClickedBtn(true);
    const data = {
      rowPerPage: rowPerPage,
      page: page,
      libelle: libelleSearch,
    };

    http
      .post("get/pays", data)
      .then((res) => {
        setRowsPays(res.data.data);
        setNb(res.data.total);
      }).catch(error => {
        console.log(error);
      })
      .finally(() => {
        setIsClickedBtn(false);
      });
  };

  useEffect(() => {
    getData();
  }, [page, rowPerPage, refresh]);

  const ClickSearch = () => {
    setPage(1);
    getData();
  };

  const ClickSave = () => {
    if (CheckAttr(libelleAjouter)) {
      setIsClickedBtn(true);

      http
        .post("create/pays", { libelle: libelleAjouter })
        .then(() => {
          handleReset();
        }).catch(error => {
          console.log(error);
        }).finally(() => {
          setIsClickedBtn(true);
        });
    }
  };

  const handleChangeForSearch = (e: any) => {
    const { value } = e.target;
    setLibelleSearch(value);

    if (!CheckAttr(value)) {
      handleReset();
    }
  };

  const handleChangeRowPerPage = (e: any) => {
    setPage(1);
    setRowPerPage(e.target.value);
  };

  const handleReset = () => {
    setLibelleAjoute("");
    setLibelleSearch("");
    setPage(1);
    reloadList();
  };

  const pagination: JSX.Element | boolean = !isClickedBtn && (
    <Stack spacing={2} direction="row" sx={{ mb: 4 }}>
      <InputLabel sx={{ color: "#fff" }}>Lignes par page :</InputLabel>
      <FormControl variant="standard" sx={{ minWidth: 50 }}>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          color="warning"
          sx={{ background: "#fff", borderRadius: 1, paddingLeft: 1 }}
          value={rowPerPage}
          onChange={handleChangeRowPerPage}
          defaultValue={5}
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={25}>25</MenuItem>
          <MenuItem value={50}>50</MenuItem>
        </Select>
      </FormControl>
      {nb > rowPerPage && (
        <Pagination
          count={Math.ceil(nb / rowPerPage)}
          color="standard"
          sx={{ button: { color: "white" } }}
          showFirstButton={true}
          showLastButton={true}
          siblingCount={0}
          boundaryCount={1}
          defaultPage={page}
          onChange={(event, value) => setPage(value)}
        />
      )}
    </Stack>
  );

  return (
    <>
      <Container maxWidth="lg">
        {isDesktopOrLaptop ? (
          <>
            <Grid container spacing={0.5} columns={{ sm: 6, md: 12 }}>
              <Grid item xs={6} sm={3} md={6}>
                <Stack
                  direction="row"
                  spacing={3}
                  display="flex"
                  justifyContent="start"
                >
                  <InputBase
                    sx={{
                      color: "white",
                      maxWidth: 150,
                    }}
                    value={libelleAjouter}
                    placeholder="Ajouter un pays ..."
                    onChange={(e) => setLibelleAjoute(e.target.value)}
                  />
                  <Button
                    variant="contained"
                    color="warning"
                    startIcon={<AddIcon />}
                    onClick={() => ClickSave()}
                    style={{ textTransform: "none" }}
                  >
                    Ajouter
                  </Button>
                </Stack>
              </Grid>
              <Grid item xs={6} sm={3} md={6}>
                <Stack
                  direction="row"
                  spacing={3}
                  display="flex"
                  justifyContent="end"
                >
                  <InputBase
                    sx={{
                      color: "white",
                      maxWidth: 150,
                    }}
                    value={libelleSearch}
                    placeholder="Chercher un pays"
                    onChange={handleChangeForSearch}
                    fullWidth
                  />
                  <IconButton
                    type="submit"
                    sx={{ p: "10px", color: "white" }}
                    aria-label="search"
                    onClick={() => ClickSearch()}
                  >
                    <SearchIcon />
                  </IconButton>
                </Stack>
              </Grid>
            </Grid>

            <TableContainer component={Paper} style={tableStyle} sx={{ mt: 1 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">Pays</StyledTableCell>
                    <StyledTableCell align="center">Action</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rowsPays.map((row) => (
                    <RowPays
                      key={row?.id}
                      row={row}
                      isDesktopOrLaptop={isDesktopOrLaptop}
                      http={http}
                      reloadList={reloadList}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box
              mt={4}
              display="flex"
              justifyContent="right"
            >
              {pagination}
            </Box>
          </>
        ) : (
          <>
            <Box sx={{
              position: 'fixed',
              width: '95%',
              top: '10.32rem',
              pr: 1.5,
              pt: 2,
              bgcolor: '#080d24',
              zIndex: 1000
            }}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                sx={{
                  bgcolor: "#fff",
                  borderRadius: 1
                }}
                placeholder="Ajouter un pays ..."
                size="small"
                fullWidth
                value={libelleAjouter}
                onChange={(e) => setLibelleAjoute(e.target.value)}
                color="warning"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        type="button"
                        aria-label="search"
                        onClick={() => ClickSave()}
                      >
                        <AddIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                id="outlined-basic"
                variant="outlined"
                sx={{
                  bgcolor: "#fff",
                  borderRadius: 1,
                  mt: 0.5,
                }}
                placeholder="chercher un pays ..."
                size="small"
                fullWidth
                value={libelleSearch}
                onChange={handleChangeForSearch}
                color="warning"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        type="button"
                        aria-label="search"
                        onClick={() => ClickSearch()}
                      >
                        <SearchIcon />
                      </IconButton>
                      <IconButton
                        type="button"
                        aria-label="refresh"
                        onClick={() => handleReset()}
                      >
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Typography sx={{ mt: 3 }}>Liste Pays</Typography>
              <Divider orientation="horizontal" sx={{ bgcolor: "#fff", mb: 2 }} />

              <Box display="flex" justifyContent="end" mb={1}>
                <Pagination
                  count={Math.ceil(nb / rowPerPage)}
                  size="small"
                  color="standard"
                  sx={{ button: { color: "white" } }}
                  showFirstButton={true}
                  showLastButton={true}
                  siblingCount={0}
                  boundaryCount={1}
                  defaultPage={page}
                  onChange={(event, value) => setPage(value)}
                />
              </Box>
            </Box>

            <Box mt={25}>
              {rowsPays.map((row) => (
                <RowPays
                  key={row?.id}
                  row={row}
                  isDesktopOrLaptop={isDesktopOrLaptop}
                  http={http}
                  reloadList={reloadList}
                />
              ))}
            </Box>

            <Stack direction="row" sx={{ mt: 3, mb: 4 }}>
              <InputLabel sx={{ color: "#fff", fontSize: 12, mt: 0.5 }}>Lignes par page :</InputLabel>
              <FormControl variant="standard" sx={{ minWidth: 48 }}>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  color="warning"
                  sx={{
                    background: "#fff",
                    borderRadius: 1,
                    paddingLeft: 1,
                    paddingTop: 0.5,
                    marginLeft: 1,
                    fontSize: 12
                  }}
                  value={rowPerPage}
                  onChange={handleChangeRowPerPage}
                  defaultValue={5}
                  size="small"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
            </Stack>
          </>
        )}
      </Container>

      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isClickedBtn}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
};
export default Pays;
